import { AutocompleteField } from "@ploy-ui/form-fields";
import { useIntl, defineMessages } from "react-intl";
import { LoginResource, LoginVendor } from "@ploy-lib/rest-resources";
import { useFetcher, useResource } from "@rest-hooks/core";
import { FormBase } from "@ploy-ui/login";

const messages = defineMessages({
	submitError: {
		id: "dealer.login.vendor.error",
		description: "An error occurred",
		defaultMessage: "An error has occured"
	},
	selectVendorLabel: {
		id: "dealer.login.field.vendor.label",
		description: "Label for vendor select field",
		defaultMessage: "Select vendor"
	},
	submitButtonText: {
		id: "dealer.login.button.continue.label",
		description: "Label for continue button",
		defaultMessage: "Continue"
	}
});

const VendorForm = () => {
	const { vendors } = useResource(LoginResource.status(), {});
	const setVendor = useFetcher(LoginResource.setVendor());

	const intl = useIntl();

	const items =
		vendors?.slice().sort((a, b) => a.name.localeCompare(b.name)) ?? [];

	const initValues = { customerId: null };

	const fieldConfig = [
		{
			name: "customerId",
			component: AutocompleteField,
			helperText: " ",
			label: intl.formatMessage(messages.selectVendorLabel),
			items: items,
			getItemLabel: (item: LoginVendor) => item.name,
			getItemValue: (item: LoginVendor) => item.id,
			fullWidth: true,
			margin: "normal",
			autoFocus: true
		}
	];
	return (
		<FormBase
			submit={values => setVendor(undefined, values)}
			initValues={initValues}
			fieldConfig={fieldConfig}
			submitButtonText={intl.formatMessage(messages.submitButtonText)}
			icon="flag-o"
			autoSubmit={true}
		/>
	);
};

export default VendorForm;
